import { Form, Icon, Input } from '@roo/roo';
import React, { useState, useEffect } from 'react';
import { FieldList } from '../../_components/FieldList';
import { getNominator } from '../../../../assets/apis/scientist';
import { renderFile } from '../../../preview/scientist/util';

const Field = Form.field;

const codeData = {
  code: '',
};

export const Code = (props) => (
  <FieldList
    {...props}
    name="nominationInfo"
    minCount={1}
    maxCount={5}
    plusText="添加提名码"
    iniData={codeData}
    itemClassName="bc relative"
  >
    <Field
      {...props}
      required
      rule={{
        validator: (rule, value, callback) => {
          if (!value) {
            return callback('请填写提名码');
          }
          // if (value.input.length != 12) {
          //   return callback('请输入完整12位提名码');
          // }
          callback();
        },
      }}
      label="提名码"
      name="code"
    >
      {({ value, handleChange }) => (
        <Codes {...props} value={value} onChange={handleChange} />
      )}
    </Field>
  </FieldList>
);

const Codes = ({ value, onChange, disabled }) => {
  const [tip, setTip] = useState({});
  useEffect(() => {
    if (value.length >= 10 && value.length <= 12) {
      getNominator(value)
        .then((res) => {
          setTip(res?.nominators[0]);
        })
        .catch((err) => {
          // console.log(err);
        });
    } else {
      setTip({});
    }
  }, []);
  return (
    <>
      <Input
        disabled={disabled} value={value} onChange={(e) => {
          const newValue = e.target.value;
          if (newValue.length < 10) {
            setTip({ valid: false, msg: '格式有误，请输入正确的提名码信息' });
          }
          if (newValue.length >= 10 && newValue.length <= 12) {
            getNominator(newValue)
              .then((res) => {
                const tip = res?.nominators[0];
                if (tip) {
                  const valid = res?.nominators[0]?.valid;
                  setTip({ valid, ...tip });
                }
                onChange(newValue);
              })
              .catch((err) => {
                onChange(newValue);
                // console.log(err);
              });
          } else {
            onChange(newValue);
          }
        }}
        maxLength={12}
        placeholder="请输入完整的提名码，每行只填写一份提名码"
      />
      <RenderMsg tip={tip} />
    </>
  );
};

const RenderMsg = ({ tip }) => {
  const { valid = null, msg } = tip;
  switch (valid) {
    case null:
      return null;
    case true:
      return <SuccessTip tip={tip} />;
    case false:
      return <ErrorTip msg={msg} />;
    default:
      return null;
  }
};

const ErrorTip = ({ msg }) => (
  <div className="patch-tips">
    <div className="info err-message">
      <Icon name="times-circle" />
      <span>{msg}</span>
    </div>
  </div>
);
const SuccessTip = ({ tip }) => {
  const {
    name = null, position = null, organization = null, nominationText = null, nominationType, nominationUrl,
  } = tip;
  return (
    <div className="patch-tips" style={{ width: '100%' }}>
      <div className="info suc-message">
        <Icon name="check-circle" />
        <span>该验证码已通过</span>
      </div>
      <div className="info suc-info">
        <div className="suc-item">
          <span>提名人:&nbsp;</span>
          <span>{name}</span>
        </div>
        <div className="suc-item">
          <span>提名人职务:&nbsp;</span>
          <span>{position}</span>
        </div>
        <div className="suc-item">
          <span>提名人工作单位:&nbsp;</span>
          <span>{organization}</span>
        </div>
        <div className="suc-item">
          <span>提名理由:&nbsp;</span>
          {
            nominationType === 'file' ? (
              <span style={{ display: 'inline-block' }}>{renderFile(tip, 'nominationUrl')}</span>
            ) : (
              <span>{nominationText}</span>
            )
          }
        </div>
      </div>
    </div>
  );
};
